import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/api";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "verifying", payment: null });

  useEffect(() => {
    const tran_id = params.get("tran_id") || params.get("payment_id");
    if (!tran_id) {
      setState({ status: "error", payment: null });
      return;
    }
    api.get(`/payments/${tran_id}`)
      .then(({ data }) => setState({ status: data.status === "success" ? "success" : "failed", payment: data }))
      .catch(() => setState({ status: "error", payment: null }));
  }, [params]);

  return (
    <div data-testid="payment-return-page" className="min-h-[80vh] flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-7 text-center fade-in-up">
        {state.status === "verifying" && (
          <>
            <Loader2 className="w-12 h-12 text-cm-accent mx-auto animate-spin" />
            <h2 className="mt-4 font-display font-bold text-xl text-cm-primary">Verifying your payment…</h2>
            <p className="mt-2 text-sm text-slate-500">Please don't close this page.</p>
          </>
        )}
        {state.status === "success" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
            <h2 className="mt-4 font-display font-extrabold text-2xl text-cm-primary">Payment successful</h2>
            <p className="mt-2 text-sm text-slate-600">Your plan is active. Thank you!</p>
            <Link to="/dealer-dashboard" data-testid="payment-go-dashboard" className="mt-5 inline-block px-5 py-3 rounded-xl bg-cm-primary text-white font-medium">Go to dashboard</Link>
          </>
        )}
        {(state.status === "failed" || state.status === "error") && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h2 className="mt-4 font-display font-extrabold text-2xl text-cm-primary">Payment was not completed</h2>
            <p className="mt-2 text-sm text-slate-600">No charge was made. Try again or contact support.</p>
            <Link to="/pricing" className="mt-5 inline-block px-5 py-3 rounded-xl bg-cm-accent text-white font-medium">Back to plans</Link>
          </>
        )}
      </div>
    </div>
  );
}
